import {
  allRequest,
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
  REQUEST_METHOD_DELETE,
  REQUEST_METHOD_POST
} from "../../../middlewares/api/actions";
import {
  getAgencyNamesUrl,
  getArtefactReferenceUrl,
  getCloneHclUrl,
  getCodelistUrl,
  getCreateArtefactsUrl,
  getDeleteArtefactUrl,
  getDownloadArtefactUrl,
  getExportArtefactUrl,
  getHierarchicalCodelistUrl,
  getMultipleDownloadArtefactUrl,
  getPaginatedCodelistUrl,
  getUpdateArtefactsUrl
} from "../../../constants/urls";
import {
  ARTEFACT_TYPE_HIERARCHICAL_CODELIST,
  getArtefactDownloadFileSaveNameAndType
} from "../../../constants/download";
import {
  getArtefactTripletFromUrn,
  getSdmxJsonFromSdmxJsonStructures,
  getSdmxJsonStructureFromArtefact,
  getSdmxJsonStructureFromHCLHierarchy,
  getStringFromArtefactTriplet,
  SDMX_JSON_HIERARCHICAL_CODELIST_LIST_KEY
} from "../../../utils/sdmxJson";

export const HIERARCHICAL_CODELISTS_LIST_HIERARCHICAL_CODELISTS_READ = 'HIERARCHICAL_CODELISTS_LIST_HIERARCHICAL_CODELISTS_READ';

export const HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CREATE = 'HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CREATE';
export const HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CREATE_SUBMIT = 'HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CREATE_SUBMIT';

export const HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_EDIT = 'HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_EDIT';
export const HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_READ = 'HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_READ';
export const HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_CHANGE = 'HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_CHANGE';
export const HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_HIDE = 'HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_HIDE';
export const HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_UPDATE_SUBMIT = 'HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_UPDATE_SUBMIT';
export const HIERARCHICAL_CODELISTS_AGENCIES_READ = 'HIERARCHICAL_CODELISTS_AGENCIES_READ';

export const HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_SAVE_SUBMIT = 'HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_SAVE_SUBMIT';

export const HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DELETE = 'HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DELETE';
export const HIERARCHICAL_CODELISTS_SELECTED_HIERARCHICAL_CODELISTS_DELETE = 'HIERARCHICAL_CODELISTS_SELECTED_HIERARCHICAL_CODELISTS_DELETE';

export const HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_SHOW = 'HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_SHOW';
export const HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_HIDE = 'HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_HIDE';
export const HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_CHANGE = 'HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_CHANGE';
export const HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD = 'HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD';

export const HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_PARENTS_AND_CHILDREN_READ = 'HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_PARENTS_AND_CHILDREN_READ';
export const HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_PARENTS_AND_CHILDREN_HIDE = 'HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_PARENTS_AND_CHILDREN_HIDE';

export const HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_SHOW = 'HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_SHOW';
export const HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_HIDE = 'HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_HIDE';
export const HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_CHANGE = 'HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_CHANGE';
export const HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_SUBMIT = 'HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_SUBMIT';

export const HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_SHOW = 'HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_SHOW';
export const HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_HIDE = 'HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_HIDE';
export const HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_CHANGE = 'HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_CHANGE';
export const HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_SUBMIT = 'HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_SUBMIT';
export const HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_REPORT_HIDE = 'HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_REPORT_HIDE';
export const HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_LIST_SHOW = 'HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_LIST_SHOW';

export const HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_READ_INCLUDED_CODELISTS = 'HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_READ_INCLUDED_CODELISTS';
export const HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_ITEMS_EMPTY = 'HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_ITEMS_EMPTY';
export const HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_READ_CODELISTS_FOR_SELECTION = 'HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_READ_CODELISTS_FOR_SELECTION';
export const HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_INCLUDED_CODELIST_ADD = 'HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_INCLUDED_CODELIST_ADD';
export const HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_INCLUDED_CODELISTS_DELETE = 'HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_INCLUDED_CODELISTS_DELETE';
export const HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_HCL_ITEMS_DELETE = 'HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_HCL_ITEMS_DELETE';
export const HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_HIERARCHY_SAVE = 'HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_HIERARCHY_SAVE';

export const HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_SET = 'HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_SET';

export const readHierarchicalCodelistsListHierarchicalCodelists = () => getRequest(
  HIERARCHICAL_CODELISTS_LIST_HIERARCHICAL_CODELISTS_READ,
  getHierarchicalCodelistUrl()
);


export const createHierarchicalCodelistsHierarchicalCodelist = () => ({
  type: HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CREATE,
});

export const editHierarchicalCodelistsHierarchicalCodelistDetail = (artefactTriplet) => ({
  type: HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_EDIT,
  artefactTriplet,
});

export const readHierarchicalCodelistsHierarchicalCodelistDetail = (hierarchicalCodelistTriplet) => {

  return {
    ...getRequest(
      HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_READ,
      getHierarchicalCodelistUrl(hierarchicalCodelistTriplet)
    ),
    hierarchicalCodelistTriplet
  }
}
 

export const changeHierarchicalCodelistsHierarchicalCodelistDetail = fields => ({
  type: HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_CHANGE,
  fields
});

export const hideHierarchicalCodelistsHierarchicalCodelistDetail = () => ({
  type: HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_HIDE
});

export const submitHierarchicalCodelistsHierarchicalCodelistCreate = (hierarchicalCodelist, hierarchicalCodelistTriplet) => ({
  ...postRequest(
    HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CREATE_SUBMIT,
    getCreateArtefactsUrl(),
    getSdmxJsonFromSdmxJsonStructures(
      [getSdmxJsonStructureFromArtefact(hierarchicalCodelist)],
      SDMX_JSON_HIERARCHICAL_CODELIST_LIST_KEY
    ),
    t => ({
      success: t('scenes.metaManager.hierarchicalCodelists.messages.create.success')
    })
  ),
  hierarchicalCodelistTriplet
});

// postRequest, getUpdateHClUrl(),
export const submitHierarchicalCodelistsHierarchicalCodelistUpdate = (hierarchicalCodelist) => ({
  ...putRequest(
    HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_UPDATE_SUBMIT,
    getUpdateArtefactsUrl() ,
    getSdmxJsonFromSdmxJsonStructures(
      [getSdmxJsonStructureFromHCLHierarchy(hierarchicalCodelist)],
      SDMX_JSON_HIERARCHICAL_CODELIST_LIST_KEY
    ),
    t => ({
      success: t('scenes.metaManager.hierarchicalCodelists.messages.update.success')
    })
  )
});

export const submitHierarchicalCodelistsHierarchicalCodelistSave = (hierarchicalCodelist) => ({
  ...putRequest(
    HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_SAVE_SUBMIT,
    getUpdateArtefactsUrl() ,
    getSdmxJsonFromSdmxJsonStructures(
      [getSdmxJsonStructureFromHCLHierarchy(hierarchicalCodelist)],
      SDMX_JSON_HIERARCHICAL_CODELIST_LIST_KEY
    ),
    t => ({
      success: t('scenes.metaManager.hierarchicalCodelists.messages.update.success')
    })
  )
});

export const readHierarchicalCodelistsAgencies = allowedAgencies => ({
  ...getRequest(
    HIERARCHICAL_CODELISTS_AGENCIES_READ,
    getAgencyNamesUrl()
  ),
  allowedAgencies
});

export const deleteHierarchicalCodelistsHierarchicalCodelist = artefactTriplet => {
  return deleteRequest(
    HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DELETE,
    getDeleteArtefactUrl("HierarchicalCodelist", artefactTriplet),
    t => ({
      success: t('scenes.metaManager.commons.messages.delete.success')
    })
  )
};

export const deleteHierarchicalCodelistsSelectedHierarchicalCodelists = artefactTriplets => allRequest(
  HIERARCHICAL_CODELISTS_SELECTED_HIERARCHICAL_CODELISTS_DELETE,
  artefactTriplets.map(() => REQUEST_METHOD_DELETE),
  artefactTriplets.map(triplet => getDeleteArtefactUrl("HierarchicalCodelist", triplet)),
  null,
  t => ({
    success: t('scenes.metaManager.commons.messages.multiDelete.success')
  }),
  artefactTriplets.map(getStringFromArtefactTriplet)
);

export const showHierarchicalCodelistsHierarchicalCodelistDownload = (artefactTriplets, lang) => ({
  type: HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_SHOW,
  artefactTriplets,
  lang
});


export const showHierarchicalCodelistsHierarchicalCodelistExportList = (artefactTriplets, lang) => ({
  type: HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_LIST_SHOW,
  artefactTriplets,
  lang
});

export const hideHierarchicalCodelistsHierarchicalCodelistDownload = () => ({
  type: HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_HIDE
});

export const changeHierarchicalCodelistsHierarchicalCodelistDownload = fields => ({
  type: HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_CHANGE,
  fields
});

export const downloadHierarchicalCodelistsHierarchicalCodelist = (artefactTriplets, downloadHierarchicalCodelistParams, lang) => {

  return (artefactTriplets && artefactTriplets.length > 1)
    ? {
      ...postRequest(
        HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD,
        getMultipleDownloadArtefactUrl(
          ARTEFACT_TYPE_HIERARCHICAL_CODELIST,
          downloadHierarchicalCodelistParams.format,
          downloadHierarchicalCodelistParams.references,
          downloadHierarchicalCodelistParams.compression,
          lang
        ),
        artefactTriplets.map(({id, agencyID, version}) => ({id, agency: agencyID, version})),
        undefined,
        undefined,
        true
      ),
      fileSave: getArtefactDownloadFileSaveNameAndType(
        artefactTriplets,
        ARTEFACT_TYPE_HIERARCHICAL_CODELIST,
        downloadHierarchicalCodelistParams.format,
        downloadHierarchicalCodelistParams.compression
      )
    }
    : {
      ...getRequest(
        HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD,
        getDownloadArtefactUrl(
          ARTEFACT_TYPE_HIERARCHICAL_CODELIST,
          artefactTriplets[0],
          downloadHierarchicalCodelistParams.format,
          downloadHierarchicalCodelistParams.references,
          downloadHierarchicalCodelistParams.compression,
          lang
        ),
        undefined,
        true
      ),
      fileSave: getArtefactDownloadFileSaveNameAndType(
        artefactTriplets,
        ARTEFACT_TYPE_HIERARCHICAL_CODELIST,
        downloadHierarchicalCodelistParams.format,
        downloadHierarchicalCodelistParams.compression
      )
    }
};

export const readHierarchicalCodelistsHierarchicalCodelistParentsAndChildren = (artefactType, artefactTriplet) => getRequest(
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_PARENTS_AND_CHILDREN_READ,
  getArtefactReferenceUrl(artefactType, artefactTriplet)
);

export const hideHierarchicalCodelistsHierarchicalCodelistParentsAndChildren = () => ({
  type: HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_PARENTS_AND_CHILDREN_HIDE
});

export const showHierarchicalCodelistsHierarchicalCodelistClone = srcTriplet => ({
  type: HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_SHOW,
  srcTriplet
});

export const hideHierarchicalCodelistsHierarchicalCodelistClone = () => ({
  type: HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_HIDE
});

export const changeHierarchicalCodelistsHierarchicalCodelistClone = fields => ({
  type: HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_CHANGE,
  fields
});

export const submitHierarchicalCodelistsHierarchicalCodelistClone = (cloneDestTriplet, srcHcl) => postRequest(
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_SUBMIT,
  getCloneHclUrl({
    id: srcHcl.id,
    agencyID: srcHcl.agencyID,
    version: srcHcl.version
  }, cloneDestTriplet),
  null,
  t => ({
    success: t('commons.artefact.messages.clone.success')
  })
);

export const showHierarchicalCodelistsHierarchicalCodelistExport = sourceTriplet => ({
  type: HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_SHOW,
  sourceTriplet
});

export const hideHierarchicalCodelistsHierarchicalCodelistExport = () => ({
  type: HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_HIDE
});

export const changeHierarchicalCodelistsHierarchicalCodelistExport = fields => ({
  type: HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_CHANGE,
  fields
});

export const submitHierarchicalCodelistsHierarchicalCodelistExport = (sourceTriplet, destination) => postRequest(
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_SUBMIT,
  getExportArtefactUrl(),
  {
    id: sourceTriplet.id,
    agency: sourceTriplet.agencyID,
    version: sourceTriplet.version,
    targetID: destination.id,
    targetAgency: destination.agencyID,
    targetVersion: destination.version,
    nodeId: destination.endpoint,
    username: destination.username,
    password: btoa(destination.password || ""),
    EnumType: "HierarchicalCodelist",
    CopyReferencedArtefact: false
  }
);

export const hideHierarchicalCodelistsHierarchicalCodelistExportReport = () => ({
  type: HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_REPORT_HIDE
});

export const readHierarchicalCodelistReferencedCodelists = (includedCodelists, childrenKey, lang) => {

  const methods = [];
  const urls = [];
  const datas = [];
  const codelistsToRead = includedCodelists || {};
  Object.values(codelistsToRead).forEach(codelistUrn => {
    const triplet = getArtefactTripletFromUrn(codelistUrn);
    methods.push(REQUEST_METHOD_POST);
    urls.push(getPaginatedCodelistUrl());
    const requestData = {
      Id: triplet && triplet.id ? triplet.id : undefined,
      AgencyId: triplet && triplet.agencyID ? triplet.agencyID : undefined,
      Version: triplet && triplet.version ? triplet.version : undefined,
      Lang: lang ? lang : undefined,
      PageNum: 1,
      PageSize: -1, 
      rebuildDb: false             
    }
    datas.push(requestData)
  });

  if (methods.length > 0) {
    return ({
      ...allRequest(
        HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_READ_INCLUDED_CODELISTS,
      methods,
      urls,
      datas),
      childrenKey
    });
  } else {
    return (
      {
        type: HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_ITEMS_EMPTY
      }   
    )  
  }

}


export const readHierarchicalCodelistDetailCodelistsForSelection = () => getRequest(
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_READ_CODELISTS_FOR_SELECTION,
  getCodelistUrl(),
);

export const addHierarchicalCodelistDetailIncludedCodelist = (triplet, childrenKey) => getRequest(
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_INCLUDED_CODELIST_ADD,
  getCodelistUrl(triplet),
  childrenKey
);

export const deleteHierarchicalCodelistDetailIncludedCodelists = (codelists) => ({
  type: HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_INCLUDED_CODELISTS_DELETE,
  codelists
});

export const deleteHierarchicalCodelistDetailHCLItems = (items) => ({
  type: HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_HCL_ITEMS_DELETE,
  items
});


export const saveHierarchicalCodelistHierarchy = (hierarchy, lang, pos) => ({
  type: HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_HIERARCHY_SAVE,
  hierarchy,
  lang,
  pos
});

export const setHierarchicalCodelist = (hierarchicalCodelist) => ({
  type: HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_SET,
  hierarchicalCodelist
});





